import { Participant, PeerState } from '../../../../pages/call/types';
import { IconostasisImageProps } from '../../../components/iconostasis-image';

export interface ExtendedNotificationItem extends NotificationItem {
    participant: Maybe<Participant>;
    waitingRoomPeer: Maybe<PeerState>;
    iconFixedSize?: boolean;
    iconostasisIcon?: IconostasisImageProps;
}

export enum NotificationType {
    INFO = 'info',
    ERROR = 'error',
    SUCCESS = 'success',
}

export interface NotificationItem {
    id: string;
    text: string | string[];
    type?: NotificationType;
    priority?: number;
    timeout?: number;
    icon?: string;
    group?: string;
    actions?: { text: string; url?: string; buttonView?: string; params?: Record<string, unknown> }[];
    withCloseButton?: boolean;
    meta?: Record<string, unknown>;
}
